import React, { Component } from 'react';
import * as axios from "axios/index";
import { NavLink, Switch, Route } from 'react-router-dom';

import { Loading } from './parts/Loading';
import {Auth} from "./Auth";


class MemberSchedule extends Component {

  constructor(props) {
    super(props);
    this.state = {schedule: {}}
  }

  componentDidMount() {
    this.load();
  }

  load() {
    axios.get('//midori-frauen.com/wp-json/posts/400')
      .then((resp) => {
        this.setState({schedule: resp.data});
      });
  }

  render() {
    return (
      <div className="member-schedule">
        {
          this.state.schedule.content ?
            (
              <div className="member-schedule-content"
                   dangerouslySetInnerHTML={{__html: this.state.schedule.content}}/>
            ) : <Loading/>
        }
      </div>
    )
  }
}

class MemberFeedback extends Component {

  constructor(props) {
    super(props);
    this.state = {feedbacks: []}
  }

  componentDidMount() {
    this.load();
  }

  load() {
    let feedbacks = [];

    async function callApi(page) {
      const params = {
        'page': page,
        'filter[posts_per_page]': 10,
        'filter[category_name]': 'feedback'
      };

      const resp = await axios.get('//midori-frauen.com/wp-json/posts', {params: params})
      feedbacks = feedbacks.concat(resp.data);
      if(resp.data.length === 10) {
        callApi.bind(this)(page + 1);
      } else {
        this.setState({feedbacks: feedbacks});
      }
    }
    callApi.bind(this)(1);
  }

  render() {

    const FeedbackNode = this.state.feedbacks.map((feedback) => {
      const FeedbackComment = feedback.meta.feedback.map((comment) => {
        return (
          <div className="feedback-content-wrapper" key={comment.feedback_name}>
            <div className="feedback-name">{comment.feedback_name}</div>
            <div className='feedback-content' dangerouslySetInnerHTML={{__html: comment.feedback_content}}/>
          </div>
        )
      });
      return (
        <div className="feedback" key={feedback.date}>
          <div className="feedback-header">
            <div className="feedback-date">{feedback.meta.date}</div>
            <div className="feedback-title">{feedback.title}</div>
          </div>
          <div className="feedback-list">{FeedbackComment}</div>
        </div>
      )
    });

    return (
      <div className="feedback-wrapper">
        {this.state.feedbacks.length === 0 ? <Loading/>
          : <div className='feedback-list-wrapper'>{FeedbackNode}</div>}
      </div>
    )
  }
}

class MemberMessage extends Component {

  constructor(props) {
    super(props);
    this.state = {message: null}
  }

  componentDidMount() {
    this.load();
  }

  load() {
    axios.get('//midori-frauen.com/wp-json/posts/976')
      .then(resp => {
        this.setState({message: resp.data});
      });
  }

  render() {
    return (
      <div className="member-schedule">
        { this.state.message === null ? <Loading/>
          : <div className='member-schedule-content'
                 dangerouslySetInnerHTML={{__html: this.state.message.content}}/>
        }
      </div>
    )
  }
}


export class Member extends Component {
  render() {
    return (
      <Auth>
        <div className="content">
          <div className="member-menu">
            <ul>
              <li><NavLink to='/member/schedule'
                           activeClassName='active'>練習日程</NavLink></li>
              <li><NavLink to='/member/feedback'
                           activeClassName='active'>講評</NavLink></li>
              <li><NavLink to='/member/message'
                           activeClassName='active'>団内連絡</NavLink></li>
            </ul>
          </div>
          <Switch>
            <Route path='/member/schedule' component={MemberSchedule}/>
            <Route path='/member/feedback' component={MemberFeedback}/>
            <Route path='/member/message' component={MemberMessage}/>
          </Switch>
        </div>
      </Auth>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Member.jsx